export enum ProcessType {
	CustomerIdentification,
	DocumentTypeIdentification,
	AttributesAssignment,
	AutoLink,
}
